<template>
  <section class="f-58">
    <div class="content_container" ref="contentContainer">
      <div class="ai_title_container" ref="aiTitle">
        <div class="ai_title">AI 工具与建议</div>
        <div class="ai-sub-title">渗透进用车的方方面面</div>
      </div>
      <div class="assistant_container" ref="assistantContainer">
        <m-video
          ref="transitionVideo"
          class="transition_video f-select-center"
          disablepictureinpicture
          playsinline
          webkit-playsinline
          muted
          src="@/v2/auto/assets/video/58/transitions.mp4"
        />
        <div class="title f-center-title" ref="title">
          用车助手，解答问题精准高效
        </div>
        <div class="sub-title f-center-sub-title" ref="subTitle">
          {{ controlList[activeIndex].subTitle }}
        </div>
        <!-- 图片后续添加 -->
        <div class="content">
          <div
            class="border_container_night video_size f-select-center"
            ref="sliderVideo"
          >
            <slider
              v-model:value="activeIndex"
              :controlBtn="false"
              :indicators="false"
              :autoplay="false"
              :touch="false"
              animation="none"
              stopOnHover
              height="100%"
              width="100%"
            >
              <slider-item v-for="(i, index) in controlList" :key="i.title">
                <div>
                  <m-video
                    :ref="`sliderVideo${index}`"
                    disablepictureinpicture
                    playsinline
                    webkit-playsinline
                    :src="i.url"
                    muted
                  />
                </div>
              </slider-item>
            </slider>
          </div>
          <replay
            ref="replay"
            class="replay"
            @click="
              () => replayVideo(this.$refs[`sliderVideo${this.activeIndex}`][0])
            "
          />
        </div>
        <div class="control_container" ref="control">
          <div class="alive_control">
            <div
              v-for="(i, index) in controlList"
              :key="index"
              class="control_item"
              :class="index === activeIndex && 'control_item_active'"
              @click="controlClick(index)"
            >
              {{ i.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { replayVideo } from '@/utils'
import { CustomEase } from 'gsap/CustomEase'
import replay from '@/components/replay.vue'
import { ScrollTrigger } from 'gsap/all'

export default {
  name: 'Assistant',
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
      videoAbortController: new AbortController(),
      controlList: [
        {
          title: '日常使用',
          subTitle: '无需查阅车辆手册，即问即答，图文并茂地指导你完成操作',
          url: require('@/v2/auto/assets/video/58/0.mp4'),
        },
        {
          title: '旅行出游',
          subTitle:
            '沿途路过景点时，可为你实时讲解、科普地方特色；运用多模态能力识别车外世界，车辆、路牌…你问我我都知道',
          url: require('@/v2/auto/assets/video/58/1.mp4'),
        },
        {
          title: '保养车辆',
          subTitle:
            '车辆需保养时，将提醒并引导车主进行预约；预约出发前主动推送 4S 店地址，导航更快捷',
          url: require('@/v2/auto/assets/video/58/2.mp4'),
        },
        {
          title: '事故维修',
          subTitle:
            '根据事故发生地点、道路类型、事故严重程度提供对应的建议和解决方案',
          url: require('@/v2/auto/assets/video/58/3.mp4'),
        },
      ],
    }
  },
  watch: {
    activeIndex(index) {
      this.nextVideoPlay(index)
    },
  },
  mounted() {
    // 是否播放过动画，在视口内只能播放一次，
    let isPlayAnimation = false
    const video = this.$refs.transitionVideo
    const { assistantContainer, title, subTitle, control, replay } = this.$refs
    ScrollTrigger.create({
      trigger: assistantContainer,
      start: 'top bottom',
      end: 'bottom top',
      onUpdate: (self) => {
        if (self.progress === 0) {
          initStart()
        }
        // 在视口下方
        if (self.progress === 1) {
          initEnd()
        }
        // 往下滑动进入
        if (self.direction === 1 && self.progress > 0.32 && !isPlayAnimation) {
          isPlayAnimation = true
          this.nextVideoPlay(this.activeIndex)
          video.currentTime = 0
          video.play()
        }
      },
    })
    // 转场视频播放完隐藏，并开始播放用车助手视频，其他元素渐显
    video.addEventListener('ended', () => {
      video.style.opacity = 0
      replayVideo(this.$refs[`sliderVideo${this.activeIndex}`][0])
      this.$gsap.to([title, subTitle, control, replay.$el], {
        ease: CustomEase.create('custom', '0.33, 0, 0.67, 1'),
        duration: 0.3,
        opacity: 1,
      })
    })
    const initStart = () => {
      this.videoAbortController.abort()
      this.videoAbortController = new AbortController()
      isPlayAnimation = false
      this.activeIndex = 0
      video.currentTime = 0
      video.style.opacity = 1
      title.style.opacity = 0
      subTitle.style.opacity = 0
      control.style.opacity = 0
      replay.$el.style.opacity = 0
    }
    const initEnd = () => {
      video.currentTime = 0
      video.style.opacity = 0
      title.style.opacity = 1
      subTitle.style.opacity = 1
      control.style.opacity = 1
      replay.$el.style.opacity = 1
    }
  },
  methods: {
    replayVideo,
    controlClick(index) {
      this.activeIndex = index
      // 重置所有视频，避免切换时闪烁
      this.controlList.forEach((_, index) => {
        const video = this.$refs[`sliderVideo${index}`][0]
        video.currentTime = 0
        video.pause()
      })
      const video = this.$refs[`sliderVideo${this.activeIndex}`][0]
      if (video) {
        replayVideo(video)
      }
    },
    // 播放完成后自动跳转到下一个视频
    nextVideoPlay(index) {
      // 清除所有 ended 事件监听器
      this.videoAbortController.abort()
      this.videoAbortController = new AbortController()
      const video = this.$refs[`sliderVideo${index}`][0]
      const nextVideoPlay = () => {
        this.activeIndex = (index + 1) % this.controlList.length
        this.controlClick(this.activeIndex)
        video.removeEventListener('ended', nextVideoPlay)
      }
      video.addEventListener('ended', nextVideoPlay, {
        signal: this.videoAbortController.signal,
      })
    },
  },
}
</script>

<style lang="less" scoped>
.f-58 {
  background-color: black;
  position: relative;
  overflow: hidden;
  .content_container {
    width: 100%;
    margin-top: 50vh;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .assistant_container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .transition_video {
      height: auto;
      pointer-events: none;
    }

    .ai_title_container {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .ai_title {
        width: 100%;
        font-size: 80px;
        font-weight: bold;
        text-align: center;
        margin: 0 auto;
        display: inline-block;
        background: linear-gradient(180deg, #4e40be -9.29%, #9a8deb 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .ai-sub-title {
        font-size: 80px;
        background: linear-gradient(180deg, #ffffff 22.12%, #dedede 83.63%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-top: 10px;
      }
    }

    .title {
      width: 100%;
      margin-top: -150px;
      line-height: 1.2;
      font-weight: bold;
      text-align: center;
      opacity: 0;
      display: inline-block;
      background: radial-gradient(
        131.96% 70.14% at 50% 18.06%,
        #eadaff 0%,
        #ffffff 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .sub-title {
      color: #ffffff;
      text-align: center;
      margin-top: 20px;
      line-height: 1.5;
      opacity: 0;
    }
    .content {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: relative;
      .video_size {
        overflow: hidden;
        video {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
        }
      }

      .replay {
        margin-top: 20px;
        color: white;
        position: relative;
        z-index: 1;
      }
    }
    .control_container {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 24px;
      margin-bottom: 40px;
      padding: 0 16px;
      opacity: 0;

      .alive_control {
        border-radius: 32px;
        background: #17181c;
        backdrop-filter: blur(8px);
        padding: 6px;
        height: max-content;
        display: flex;
        width: max-content;
        gap: 6px;
        flex-wrap: wrap;
        justify-content: center;
        border: 1px solid rgba(255, 255, 255, 0.1);

        .control_item {
          cursor: pointer;
          font-size: 15px;
          border-radius: 26px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: max-content;
          padding: 0 20px;
          height: 36px;
          color: rgba(255, 255, 255, 0.7);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          user-select: none;
          letter-spacing: 0.2px;
        }

        .control_item_active {
          color: #ffffff;
          font-weight: 500;
          background-color: #000000;
        }
      }
    }
  }
}
</style>
